import { render, staticRenderFns } from "./Kinkekaart2.vue?vue&type=template&id=0cfb4d8a"
import script from "./Kinkekaart2.vue?vue&type=script&lang=js"
export * from "./Kinkekaart2.vue?vue&type=script&lang=js"
import style0 from "./Kinkekaart2.vue?vue&type=style&index=0&id=0cfb4d8a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports